import { getServerUrl } from '@hooks/useApi'
import { type Style } from 'mapbox-gl'

import type { MapboxMode } from './MapboxWrapper'

const day_night = 'mapbox://styles/mapbox/satellite-v9'
const depth = 'mapbox://styles/mapbox/streets-v11'
const globe = 'mapbox://styles/mapbox/satellite-streets-v11'
const selfHosted = getServerUrl('/styles/dark/style.json')

export function isApiKeyRequired (style: string | Style) {
  return style !== selfHosted
}

export default function getMapboxStyle (mode: MapboxMode) {
  if (mode === 'mapbox3d' || mode === 'globe') {
    return globe
  } else if (mode === 'depth') {
    return depth
  } else if (mode === 'day_night') {
    return day_night
  } else {
    return selfHosted
  }
}
